import httpRequest from "../../services/httpreq";
import { isDefined } from "../shared";

export function getLensAll(mfrid) {
  return new Promise((resolve, reject) => {
    let opt = {
      cmd: "getLensAll",
      body: {
        mfrid,
        page: 1,
        pagelength: 50
      },
      token: window.token
    };

    httpRequest(opt, (response) => {
      if (response && response.message === "OK" && response.obj && response.obj.lens) {
        let lens = response.obj.lens;
        lens.sort((a, b) => {
          return a.lenname < b.lenname ? 1 : -1;
        });
        resolve(response.obj.lens);
      } else {
        reject(response.message);
      }
    });
  });
}
export function getLenContent(_id) {
  return new Promise((resolve, reject) => {
    let opt = {
      cmd: "getLenContent",
      body: {
        _id
      },
      token: window.token
    };

    httpRequest(opt, (response) => {
      if (response && response.message === "OK" && response.obj && response.obj.len) {
        resolve(response.obj.len);
      } else {
        reject(response.message);
      }
    });
  });
}
export function addLen(mfrid, lenname, r, ecc, width, toricR) {
  return new Promise((resolve, reject) => {
    let opt = {
      cmd: "addLen",
      body: {
        mfrid,
        lenname,
        r,
        ecc,
        width,
        toric_r: toricR
      },
      token: window.token
    };
    httpRequest(opt, (response) => {
      if (response && response.message === "OK" && response.obj && response.obj.len) {
        resolve(response.obj.len);
      } else {
        reject(response.message);
      }
    });
  });
}

export function delAllLens(mfrid) {
  return new Promise((resolve, reject) => {
    if (!isDefined(mfrid)) {
      resolve();
      return;
    }
    let opt = {
      cmd: "delLen",
      body: {
        mfrid
      },
      token: window.token
    };
    httpRequest(opt, (response) => {
      if (response && response.message === "OK") {
        resolve();
      } else {
        reject(response.message);
      }
    });
  });
}

export function delLen(_id) {
  return new Promise((resolve, reject) => {
    let opt = {
      cmd: "delLen",
      body: {
        _id
      },
      token: window.token
    };
    httpRequest(opt, (response) => {
      if (response && response.message === "OK") {
        resolve();
      } else {
        reject(response.message);
      }
    });
  });
}

export function updateLen(_id, mfrid, lenname, r, ecc, width, toricR) {
  return new Promise((resolve, reject) => {
    let opt = {
      cmd: "updateLen",
      body: {
        _id,
        mfrid,
        lenname,
        r,
        ecc,
        width,
        toric_r: toricR
      },
      token: window.token
    };
    httpRequest(opt, (response) => {
      if (response && response.message === "OK") {
        resolve();
      } else {
        reject(response.message);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/topography/js/Rgp-Len.js